import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import v from "./iconfont.es5471.js";
const d = {
  display: "block"
}, x = ({ size: t = 16, useVw: l, useRem: c, color: n, withColor: o, removeClassName: e, disableSSR: m, style: r, ...p }) => {
  const f = r ? { ...d, ...r } : d;
  return /* @__PURE__ */ a.createElement(v, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-NFT", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), height: l ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: f, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: e ? "" : "32px-NFT"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: e ? "" : "normal",
        fill: o ? i(n, 0, "#262933") : "#262933",
        datafollowfill: o ? i(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M14.69 4.828a2.104 2.104 0 0 1 2.067-.021l2.64 1.451 6.23 3.646a2.104 2.104 0 0 1 1.04 1.816v9.066a1.89 1.89 0 0 1-.978 1.656l-.723.398a.902.902 0 1 0 .869 1.58l.723-.398a3.693 3.693 0 0 0 1.913-3.236V11.72a3.908 3.908 0 0 0-1.934-3.373l-6.24-3.651a.89.89 0 0 0-.02-.012l-2.651-1.458a3.908 3.908 0 0 0-3.837.04L5.482 8.06a3.908 3.908 0 0 0-1.954 3.384v9.214c0 1.425.776 2.738 2.024 3.424l8.564 4.71a3.908 3.908 0 0 0 3.767 0l2.89-1.59a.902.902 0 0 0-.87-1.58l-2.89 1.59a2.104 2.104 0 0 1-2.027 0l-8.564-4.71a2.104 2.104 0 0 1-1.09-1.844v-9.213c0-.752.4-1.447 1.052-1.823l8.307-4.795Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M19.559 12.096a.9.9 0 0 0-1.8 0v5.04l-3.687-5.17c-.596-.835-1.913-.414-1.913.613v7.369a.9.9 0 1 0 1.8 0v-5.04l3.686 5.169c.596.835 1.914.414 1.914-.613v-7.368Z"
        }
      )
    )
  )));
}, F = x;
export {
  F as default
};
